import * as $ from 'jquery';
import { Observable } from 'common/barrels/rx';

import { ContainerControl } from 'runtime/controls/containercontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';

import 'runtime/styles/controls/panelcontainer.less';

export class PanelContainer extends ContainerControl {
    private $container: JQuery;

    constructor(args: ControlArgs) {
        super(args);
            
        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container').addClass(this.config.isScrollable ? 'panel-scrollable' : 'panel-nonscrollable');
                
        this.$container = this.prepareContainer().applyBackground(this.config['content.Background']);
                
        this.applyTooltip(this.$element);

        this.subscriptions = this.processBindings(this.config);

        this.bindElements(this.$container.children(), this);

        this.initialize();
    }

    private prepareContainer() {
        if (!this.config.isScrollable || (!this.config.minimumInteriorHeight && !this.config.minimumInteriorWidth))
            return this.$element;

        var $children = this.$element.children();

        return $('<div />')
            .addClass('panel-scrollable-min')
            .conditionalCss(this.config.minimumInteriorHeight, 'min-height')
            .conditionalCss(this.config.minimumInteriorWidth, 'min-width')
            .appendTo(this.$element)
            .append($children);
    }

    focus() { }

    protected applyScrollVetoBehavior() {
        if (!this.config.isScrollable)
            this.installScrollVeto(this.$element);
    }

    applyEnabledState(value: boolean) {
        this.propagateEnabledStateToChildElements(this.$container, this.writableAgnosticDerivedEnabledState());
    }

    resizeStream(): Observable<{}> {
        return this.stretches() ? this.container.resizeStream() : Observable.never();
    }
}

registerBinding('panelcontainer', PanelContainer);